<template>
  <div
    :class="$style.root"
    :data-has-pagination="childData?.meta?.pagination?.page < childData?.meta?.pagination?.pageCount ? '' : null"
  >
    <LayoutPageHeaderComponent :data="localizedData" />

    <ul :class="$style.list">
      <li
        :class="$style.item"
        v-for="(entry, index) in childData?.data"
      >
        <SharedThumbnailEssayComponent
          :data="entry"
          :class="$style.content"
          :data-last-of-type="index === childData?.data?.length - 1 ? '' : null"
        />
      </li>
    </ul>

    <LayoutPaginationComponent
      :pagination="childData?.meta?.pagination"
      :paginateChildData="paginateChildData"
    />

    <CoreTextComponent
      v-if="introduction"
      :string="introduction"
      :class="$style.introduction"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  pageData: Object,
  childData: {
    type: Object,
    required: false,
  },
  paginateChildData: {
    type: Function,
    required: false,
  }
})

const getLocalizedData = i18nGetLocalizedData

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData?.data))
})
const introduction = computed(() => i18nGetLocalizedString(localizedData.value?.introductions))

</script>

<style module lang=scss>
.root {
  position: relative;
}

.introduction {
  composes: font-size-small container--default from global;
  margin-top: calc(var(--unit--vertical) * 2);
  --core-text--heading--font-size: var(--font-small--font-size);
  --core-text--heading--line-height: var(--font-small--line-height);

  columns: 2;
  gap: var(--unit--horizontal);

  @media (max-width: $breakpoint-s) {
    columns: 1;
  }
}

.introduction h2 {
  text-transform: uppercase;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.list {
  composes: reset-list from global;
}

.item {
  composes: container--default from global;
  padding: 0 var(--unit--horizontal);
}

.content {
  composes: font-size-large from global;
  display: block;

  border-top: var(--stroke--medium) solid var(--color--primary);

  padding-top: calc(var(--unit--vertical) * 2 - (var(--lh) - var(--fs)));
  padding-bottom: calc(var(--unit--vertical) * 2);
}

.content[data-last-of-type] {
  border-bottom: var(--stroke--medium) solid var(--color--primary);
}
 </style>
